// Server-role capability logic — the single source of truth for "can this user
// see/do X" in the UI. It mirrors the server's `require_server_role` ladder
// (crates/control-plane handlers::require_server_role); the server remains the
// real gate, this just decides what the UI offers.

import type { ServerRole } from "../api";

/** Ascending privilege. An unknown/missing role is treated as the floor. */
const RANK: Record<ServerRole, number> = {
  guest: 0,
  member: 1,
  manager: 2,
  admin: 3,
};

export function roleRank(role: ServerRole | string | undefined): number {
  return RANK[(role ?? "guest") as ServerRole] ?? 0;
}

/** True when `role` meets or exceeds `min`. */
export function hasServerRole(
  role: ServerRole | string | undefined,
  min: ServerRole,
): boolean {
  return roleRank(role) >= RANK[min];
}
